import React from 'react';
export var TextButton = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick;
    var defaultClasses = 'sui-antialiased sui-font-regular sui-text-base sui-tracking-normal sui-normal-case sui-text-primary sui-line-clamp-none sui-text-primary sui-underline focus-visible:sui-bg-focus focus-visible:sui-outline-0';
    return (React.createElement("button", { type: "button", onClick: onClick, className: "".concat(defaultClasses, " ").concat(className) }, children));
};
